import React from 'react';
import {Radar} from '@nivo/radar';
import Popover from 'react-popover';

import {getAreaIcon} from '../../../services/utilities';

import s from './Radar.css';

function extractWordEvaluationFrom(areaValue) {
  let value = parseFloat(areaValue, 10);

  if (value < 2 && value >= 1) {
    return 'Presidio insufficiente';
  }

  if (value < 3 && value >= 2) {
    return 'Presidio sufficiente';
  }

  if (value < 4 && value >= 3) {
    return 'Presidio buono';
  }

  if (value >= 4) {
    return 'Presidio ottimo';
  }
}

function Tooltip({Icon, area}) {
  return (
    <div className={s.Tooltip}>
      <Icon width={'2em'} height={'2em'} />
      <div className={s.AreaName}>
        <div>{`Area ${area.name}`}</div>
        <div>{extractWordEvaluationFrom(area.value)}</div>
      </div>
    </div>
  );
}

function IconWithTooltip({Icon, anchor, area}) {
  const [isOpen, setIsOpen] = React.useState(false);

  function openTooltip() {
    setIsOpen(true);
  }

  function closeTooltip() {
    setIsOpen(false);
  }

  return (
    <Popover
      isOpen={isOpen}
      body={<Tooltip Icon={Icon} area={area} />}
      tipSize={0.1}
    >
      <g transform={`translate(${anchor === 'end' ? -40 : -20}, -20)`}>
        <Icon width={'3em'} height={'3em'} anchor={'end'} />
        <rect
          className={s.Icon}
          onMouseEnter={openTooltip}
          onMouseLeave={closeTooltip}
          fill="transparent"
          width={'3.5em'}
          height={'3.5em'}
        />
      </g>
    </Popover>
  );
}

export default function RadarChart({
  areas = [{id: 1, value: 2}, {id: 2, value: 4}, {id: 3, value: 1}]
}) {
  return (
    <Radar
      animate={false}
      data={areas.map(area => ({
        id: area.id,
        value: Math.round(parseFloat(area.value))
      }))}
      maxValue={5}
      fillOpacity={0.6}
      indexBy="id"
      keys={['value']}
      gridShape="circular"
      enableDots={false}
      isInteractive={false}
      blendMode={'darken'}
      width={500}
      height={600}
      margin={{top: 70, bottom: 70, left: 70, right: 70}}
      colors={'url(#linear-gradient)'}
      gridLabelOffset={32}
      gridLabel={function({id, anchor}) {
        const Icon = getAreaIcon(id);
        const area = areas.find(area => area.id === id);

        return <IconWithTooltip Icon={Icon} anchor={anchor} area={area} />;
      }}
    />
  );
}
